/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserRoleEnum } from './userRoleEnum';


export interface InlineObject { 
    email?: string;
    name?: string;
    phoneNumber?: string;
    specialisation?: string;
    title?: string;
    password?: string;
    fcmToken?: string;
    role?: UserRoleEnum;
    profileImage?: Blob;
}

